<template>
    <div class="menu-years-wrap">
            <div class="menu-years-title">
                <descr :text="'Выберите период торговли'"
                :direction="'left'"></descr>
            </div>
            <div class="menu-years" @click="showOrHideMenu">{{activeItem}}</div>
            <!--<div class = "menu-years-icon" @click="showOrHideMenu">
                <i class="icon-arrow-down"></i>
            </div>-->
            <div class="menu-years-menu" v-show="showMenu">
                <div class="menu-years-menu-item"
                    v-for="(item, index) in getYears" :key="index"
                @click="changeItem(item)">{{item}}</div>
            </div>
    </div>
</template>
<script>
import Description from "../../../ui-components/description"
export default {
    components: {
        'descr':Description
    },
    data() {
        return {
            showMenu:false,
            activeItem: 'Весь период'
        }
    },
    props: {
        years:{default:[]}
    },
    computed: {
        getYears() {
            let yearsObject = [];
            this.years.push('Весь период');
            return this.years;
        }
    },
    methods: {
        showOrHideMenu(){
            this.showMenu = !this.showMenu;
        },
        changeItem(item){
            if(item != 'Весь период') {
                this.activeItem = item + ' ' + 'год';
            }
            else {
               this.activeItem = item
            }
            this.showMenu = !this.showMenu;
            this.$emit('changeYear', item);
        }
    }
}
</script>
<style lang="less" scoped>
.menu-years {
    font-family: Arimo;
    font-size: 14px;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    margin-right: 0px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 145px;
    height: 40px;
    box-sizing: border-box;
    padding: 0px 8px 0px 8px;
    color: #374b62;
    background: @colors[green];
    cursor: pointer;
    &-wrap {
        display: flex;
        position: relative;
        align-items: center;
        //max-height: 23px;
    }
    &-title {
        font-family: Arimo;
        font-size: 18px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1;
        letter-spacing: 0.4px;
        color: #aabed2;
        text-transform: uppercase;
        margin-right: 8px;
        padding-top: 3px;
    }
    &-icon {
        height: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 10px;
        text-align: left;
        color: #aabed2;
        cursor: pointer;
        i {
            margin-bottom: 2px;
            margin-right: 4px;
        }
    }
    &-menu {
        position: absolute;
        //width: 100%;
        display: block;
        //background-color: #506b89;
        width: 145px;
        top: 40px;
        right: 0px;
        overflow: hidden;
        text-align: center;
        z-index: 2;
        background-color: #324258;
        //-webkit-box-shadow: 0px 8px 15px 5px rgba(0, 0, 0, 0.2);
        //box-shadow: 0px 8px 15px 5px rgba(0, 0, 0, 0.2);
        &-item {
            font-family: Arimo;
            font-size: 12px;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
            font-style: normal;
            font-stretch: normal;
            letter-spacing: 0.4px;
            color: #aabed2;
            text-transform: uppercase;
            cursor: pointer;
            height: 30px;
            border-bottom: 0.5px solid #293546;
            &:last-child {
                border-bottom:none;
            }
        }
    }

}
</style>
